module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av307-b5567a348e5dd2b7acd75f9179ee2993.jpg";